module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image5.4a86f742.webp";